import isInResolution from "./is-in-resolution";

/**
 * Get defined resolutions Map and set the new "current" entry
 * @param {ResolutionProps} resolutions
 */
const setCurrentResolution = (resolutions) => {
  /** @type {keyof ResolutionObjectProps} */
  let last = "all";

  for (const resolution of resolutions.keys()) {
    if (!isInResolution(resolution)) {
      break;
    }

    last = resolution;
  }

  /** Set the `current` resolution */
  resolutions.set("current", resolutions.get(last));
};

export default setCurrentResolution;
